<div>
  <form *ngIf="items" (ngSubmit)="onSubmit()" [formGroup]="form">
    <mat-expansion-panel [expanded]="expandido===true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h6 class="titulo-solicitud">{{descripcion}}</h6>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngFor="let item of items; let i=index; let even=even;" class="row">
        <!--<app-dynamic-form-contenido [item]="item" [form]="form"></app-dynamic-form-contenido>-->
        <!--<div *ngIf="even">-->
        <div *ngIf="(i % 3) === 0">
          <app-dynamic-form-contenido [item]="items[i]" [form]="form"></app-dynamic-form-contenido>
          <app-dynamic-form-contenido [item]="items[i+1]" [form]="form"></app-dynamic-form-contenido>
          <app-dynamic-form-contenido [item]="items[i+2]" [form]="form"></app-dynamic-form-contenido>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m12 l12" style="text-align:center;">
          <button mat-raised-button type="submit" color="accent" [disabled]="!form.valid">Guardar</button>
          <br><br>
        </div>
      </div>


    </mat-expansion-panel>
  </form>

  <!--<div *ngIf="payLoad" class="form-row">
    <strong>Saved the following values</strong><br>{{payLoad}}
  </div>-->
</div>
